import LineInterface from 'app/interfaces/LineInterface';
import {linesService} from 'app/store/global';

export const hasUserBet = (line: LineInterface, gamerNum: number): boolean => {
    const ons = linesService.user_bets && linesService.user_bets.on && linesService.user_bets.on[line.id];
    return ons && Boolean(ons.some(r => r === gamerNum));
};
